/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'

export function findManySettings (params?: Record<string, any>): Promise<Partial<Settings>> {
  return rest.get(`/api/settings?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function putSettings (settings: Record<string, any>) {
  return rest.put('/api/settings', {
    body: JSON.stringify(settings),
    headers: { 'Content-Type': 'application/json' }
  })
}
